// extracted by mini-css-extract-plugin
export var cardIcon = "_5k-4";
export var checkboxCard = "_5k-0";
export var checkboxCardSelected = "_5k-3";
export var disabled = "_5k-1";
export var outerBorder = "_5k-2";
export var spacerMedium = "_5k-7";
export var spacerSmall = "_5k-6";
export var spacerXsmall = "_5k-5";